import { render, staticRenderFns } from "./EditScore.vue?vue&type=template&id=e8616128&scoped=true"
import script from "./EditScore.vue?vue&type=script&lang=js"
export * from "./EditScore.vue?vue&type=script&lang=js"
import style0 from "./EditScore.vue?vue&type=style&index=0&id=e8616128&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8616128",
  null
  
)

export default component.exports